import { useEffect, useRef } from 'react';

/** useEffect com debounce — evita gravações IDB a cada tecla. */
export function useDebouncedEffect(
  effect: () => void | (() => void),
  deps: React.DependencyList,
  delayMs: number
): void {
  const effectRef = useRef(effect);
  effectRef.current = effect;

  useEffect(() => {
    const timer = window.setTimeout(() => {
      effectRef.current();
    }, delayMs);
    return () => window.clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
